module.exports = __webpack_public_path__ + "img/screenshot_board_1_super_pos.b5a707db.png";